import React from 'react';
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import {renderFieldMonetarioFormulario, renderFieldText, required} from '../../util/inputs';
import Autorizacao from '../../security/Autorizacao';
import {getGestorEmpresa, getOperadorEmpresa, getPerfisVendedores, PERFIL_ADMIN} from '../../security/securityContext';
import informarComprovantePagamento from '../../actions/forma-pagamento/informarComprovantePagamento';
import {tamanhoArquivoUpload} from '../../util/applicationContext';
import {showErrorMsg, showSuccessMsg} from '../../util/messagesUtil';

export class ModalInformarComprovante extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }


    fecharModal() {
        $('#modalInformarComprovantePagamento')
            .modal('hide');
        $('#modalInformarComprovantePagamento')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.reset('formIncluirFormarPagamento')
    }

    submit(values) {
        const formaPagamento = {
            idFormaPagamento: values.idFormaPagamento,
            base64Comprovante: values.base64Comprovante,
            numeroComprovante: values.numeroComprovante,
            nomeComprovante: values.nomeComprovante,
        };

        this.props.informarComprovantePagamento(formaPagamento, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Fechamento enviado com sucesso');

                this.fecharModal();
                this.props.buscarPedidos();
            })
    }

    handleChange(event) {
        const file = event.target.files[0];
        if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
            return
        }
        if (file.size > tamanhoArquivoUpload) {
            showErrorMsg('Tamanho do arquivo excede 20 MB');
            return
        }
        this.converterParaBase64(file)
    }

    converterParaBase64(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            this.props.changeFieldValue('formIncluirFormarPagamento',
                'base64Comprovante', reader.result);
            this.props.changeFieldValue('formIncluirFormarPagamento',
                'nomeComprovante', file.name);
        }.bind(this);
    }

    limparFormulario() {
        this.props.reset('formInformarComprovante');
        this.removerArquivo();
    }

    exibirAnexar() {
        if (this.props.base64Comprovante || this.props.urlComprovante) {
            return (
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id),
                    ...getPerfisVendedores(this.props.empresaSelecionada.id),
                ]}>
                    <div className="row align-items-center mt-2">
                        <div className='col-12 label-cancelamento'>
                            <label>Comprovante:</label>
                        </div>
                        <div className='ml-4'>{this.props.nomeComprovante}</div>
                        {this.exibirRemoverComprovante()}
                        {this.exibirBaixarComprovante()}
                    </div>
                </Autorizacao>)
        }
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
            ]}>
                <div className='input-wrapper mt-3'>
                    <label className='btn-laranja' htmlFor='input-file'>
                        <div className='row align-items-center'>
                            <i className="material-icons aberto">&#xe2c3;</i>
                            <strong className='ml-2'>Anexar comprovante de pagamento</strong>
                        </div>
                    </label>
                    <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                           onChange={this.handleChange.bind(this)}/>
                </div>
                <label style={{fontSize: 'smaller'}}>
                    * Tamanho máximo permitido : 20 MB
                </label>
            </Autorizacao>)
    }

    exibirBaixarComprovante() {
        if (this.props.urlComprovante) {
            return (<Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
            ]}>
                <button type="button" className="btn btn-editar"
                        title='Baixar'
                        onClick={() => window.open(this.props.urlComprovante, '_blank')}>
                    <i className="material-icons nav-icon" style={{
                        color: '#fa8d42'
                    }}>&#xe2c0;</i>
                </button>
            </Autorizacao>)
        }
        return '';
    }

    removerArquivo() {
        this.props.changeFieldValue('formIncluirFormarPagamento',
            'base64Comprovante', null);
        this.props.changeFieldValue('formIncluirFormarPagamento',
            'nomeComprovante', '');
        this.props.changeFieldValue('formIncluirFormarPagamento',
            'urlComprovante', null);

        this.props.changeFieldValue('formIncluirFormarPagamento',
            'numeroComprovante', '');
    }

    exibirRemoverComprovante() {
        return (<Autorizacao perfisPermitidos={[PERFIL_ADMIN,
            getGestorEmpresa(this.props.empresaSelecionada.id),
            ...getPerfisVendedores(this.props.empresaSelecionada.id),
        ]}>
            <button type="button" className="btn btn-editar"
                    title='Remover'
                    onClick={() => this.removerArquivo()}>
                <i className="material-icons nav-icon" style={{
                    color: 'red'
                }}>&#xe14c;</i>
            </button>
        </Autorizacao>)
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotoesVendedor(invalid, submitting) {
        return (
            <div className="modal-footer">
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id),
                    ...getPerfisVendedores(this.props.empresaSelecionada.id),
                ]}>
                    <button type="submit" className="btn btn-laranja" id="btn-confirmar-acesso-autos"
                            disabled={invalid || submitting}>
                        ENVIAR
                    </button>
                </Autorizacao>
            </div>)
    }

    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;

        return (
            <div className="modal fade show" role="dialog"
                 id="modalInformarComprovantePagamento" aria-labelledby="modalInformarComprovantePagamento"
                 aria-hidden="true"
                 data-backdrop="static">
                <div className="modal-dialog modal-info modal-md modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Pedido {this.props.pedido ? this.props.pedido.id : ''}</h3>
                            <button type="button" className="close" data-dismiss="modal"
                                    id="btnmodalInformarComprovantePagamento"
                                    onClick={() => this.limparFormulario()}
                                    aria-label="Close">
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <form onSubmit={handleSubmit(this.submit)}>
                            <div className="modal-body corpo-modal">
                                <div className="form-group">
                                    {this.exibirAnexar()}
                                </div>
                                <div className="form-group">
                                    <Field name="numeroComprovante" type="text" component={renderFieldText}
                                           validate={[required]}
                                           css="form-control col-md-6" label="Número comprovante:"/>
                                </div>
                                <Field name="valorTotal" type="text" readOnly={true}
                                       component={renderFieldMonetarioFormulario}
                                       css="form-control col-md-4 mb-2" label="Valor total do pedido"/>
                                <Field name="idFormaPagamento" type="hidden" component={renderFieldText}
                                       css="form-control col-md-12"/>
                                {this.exibirBotoesVendedor(invalid, submitting)}
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        )
    }
}

const seletor = formValueSelector('formIncluirFormarPagamento');

export function mapStateToProps(state) {
    return {
        nomeComprovante: seletor(state, 'nomeComprovante'),
        urlComprovante: seletor(state, 'urlComprovante'),
        base64Comprovante: seletor(state, 'base64Comprovante'),
        empresaSelecionada: state.empresaSelecionada
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        informarComprovantePagamento
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formIncluirFormarPagamento',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalInformarComprovante));
